import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'HT_DCPERIOD',
  version: 1,
  label: 'Hilbert Dominant Cycle Period',
  pane: 'sub',
  category: 'cycles',
  series: 'normal',
  precision: 2,
  order: 30,
  inputs: [],
  outputs: [line('period', 'Period', COLOR.blue)],
  talib: { functions: ['HT_DCPERIOD'], expr: 'HT_DCPERIOD(close)' },
  listed: true,
  tailSafe: true,
  // TA_HT_DCPERIOD_Lookback: 32 (see TA_MAMA_Lookback).
  lookback: () => 32,
}
export default def
